import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-ai-featured-collections',
  templateUrl: './ai-featured-collections.component.html',
  styleUrls: ['./ai-featured-collections.component.scss']
})
export class AIFeaturedCollectionsComponent implements OnInit {
  slidesData: any = [];
  featuredData: any = [
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
    {},
  ];
 loader = false;
  constructor(private dataService: DataService,) { }

  async ngOnInit() {
    (await this.dataService.getFeaturedBannerService()).subscribe((singleservice) => {
      this.slidesData = [];
      this.slidesData = singleservice;
    });
    
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.featuredData = [];

        this.featuredData = singleservice.filter((data)=>{
          return data["isFeatured"] && data["isAICollection"]
        })

        //console.log(this.featuredData);
      }
    );
  }

}
